export default function TermsConditions() {
  return (
    <div className="terms">
        <h1 className="terms__main-heading">Terms and Conditions</h1>
        <h3 className="terms__sub-heading">Effective Date: January 1, 2025</h3>

        <h2 className="terms__sub-heading">1. Overview</h2>
        <p className="terms__description">
            Amplify Loyalty LLC (“Amplify Loyalty,” “we,” “our,” or “us”) provides software tools and integrations
            designed to help merchants manage loyalty programs, analytics, and marketing. These Terms and Conditions (“Terms”)
            govern your use of the Amplify Loyalty platform, website, and related services (collectively, the “Service”).
            By using our Service, you agree to these Terms.
        </p>

        <h2 className="terms__sub-heading">2. Eligibility</h2>
        <p className="terms__description">
            You must be at least 18 years old and capable of entering into legally binding agreements to use our Service.
            By using the Service, you represent that you meet these requirements.
        </p>

        <h2 className="terms__sub-heading">3. Account Registration and Security</h2>
        <ul className="terms__list">
            <li className="terms__list-item">You must register an account or connect your Shopify store to use the Service.</li>
            <li className="terms__list-item">You agree to provide accurate and complete information during registration.</li>
            <li className="terms__list-item">You are responsible for maintaining the confidentiality of your login credentials.</li>
            <li className="terms__list-item">You must notify us immediately of any unauthorized access or account use.</li>
        </ul>

        <h2 className="terms__sub-heading">4. Use of the Service</h2>
        <p className="terms__description">
            You may use the Service only for lawful business purposes and in accordance with these Terms.
            You agree not to:
        </p>
        <ul className="terms__list">
            <li className="terms__list-item">Use the Service for any illegal, fraudulent, or unauthorized purpose.</li>
            <li className="terms__list-item">Attempt to reverse-engineer, copy, or modify the Service’s code or functionality.</li>
            <li className="terms__list-item">Circumvent rate limits, security features, or access restrictions.</li>
            <li className="terms__list-item">Send spam or violate privacy and marketing laws using our platform.</li>
        </ul>

        <h2 className="terms__sub-heading">5. Merchant Responsibilities</h2>
        <p className="terms__description">
            When using Amplify Loyalty, you are responsible for ensuring your business complies with all applicable laws,
            including consumer protection, data privacy, and marketing regulations. This includes:
        </p>
        <ul className="terms__list">
            <li className="terms__list-item">Obtaining proper consent before collecting or using customer data.</li>
            <li className="terms__list-item">Complying with all SMS and email marketing laws (e.g., TCPA, CAN-SPAM).</li>
            <li className="terms__list-item">
            Ensuring end-customers understand how their data is collected and used in your loyalty program.
            </li>
        </ul>
        <p className="terms__description">
            Amplify Loyalty provides tools to help facilitate compliance, but the merchant is solely responsible for how
            these tools are used.
        </p>

        <h2 className="terms__sub-heading">6. Fees and Billing</h2>
        <p className="terms__description">
            Amplify Loyalty charges subscription and/or usage-based fees through the Shopify Billing API.
            By installing and using our app, you authorize Shopify to charge your account for these fees.
        </p>
        <p className="terms__description">
            Fees are non-refundable except as required by law or expressly stated otherwise.
        </p>

        <h2 className="terms__sub-heading">7. Intellectual Property</h2>
        <p className="terms__description">
            All intellectual property rights in the Service, including code, design, and trademarks, are owned by Amplify Loyalty LLC.
            You may not copy, modify, or distribute any part of the Service without written consent.
        </p>
        <p className="terms__description">
            Merchants retain ownership of their store and customer data but grant Amplify Loyalty a limited license
            to process and display that data as needed to provide the Service.
        </p>

        <h2 className="terms__sub-heading">8. Data and Privacy</h2>
        <p className="terms__description">
            Our collection and use of data are governed by 
            our <a href="/privacy-policy">Privacy Policy</a> and <a href="/mobile-terms">Mobile Terms of Service</a>.
            By using the Service, you consent to our data handling practices, including limited sharing with
            trusted third-party partners such as Google, Meta, and Klaviyo.
        </p>

        <h2 className="terms__sub-heading">9. Third-Party Integrations</h2>
        <p className="terms__description">
            The Service integrates with third-party platforms such as Shopify and Klaviyo.
            Amplify Loyalty is not responsible for the security, data handling, or uptime of these external services.
            Use of integrations is subject to each third party’s own terms and privacy policy.
        </p>

        <h2 className="terms__sub-heading">10. SMS and Email Communications</h2>
        <p className="terms__description">
            If you use Amplify Loyalty’s SMS or email features, you are solely responsible for obtaining subscriber consent,
            disclosing messaging terms, and processing opt-out requests in compliance with applicable laws.
            Amplify Loyalty provides the tools but does not assume legal responsibility for merchants’ use of them.
        </p>

        <h2 className="terms__sub-heading">11. Termination</h2>
        <p className="terms__description">
            We may suspend or terminate your access to the Service at any time for violation of these Terms or applicable law.
            Upon termination, your access will end immediately, and your data may be deleted after a reasonable retention period.
        </p>

        <h2 className="terms__sub-heading">12. Disclaimers and Limitation of Liability</h2>
        <p className="terms__description">
            The Service is provided “as is” and “as available” without warranties of any kind, express or implied.
            To the fullest extent permitted by law:
        </p>
        <ul className="terms__list">
            <li className="terms__list-item">
            Amplify Loyalty shall not be liable for indirect, incidental, or consequential damages.
            </li>
            <li className="terms__list-item">
            Total liability for any claim shall not exceed the total fees paid in the 6 months preceding the claim.
            </li>
        </ul>

        <h2 className="terms__sub-heading">13. Indemnification</h2>
        <p className="terms__description">
            You agree to indemnify and hold Amplify Loyalty, its employees, and affiliates harmless from any claims, damages,
            or losses arising from your use of the Service, breach of these Terms, or violation of applicable laws.
        </p>

        <h2 className="terms__sub-heading">14. Modifications</h2>
        <p className="terms__description">
            We may update these Terms periodically. Updates will be posted on our website with the revised effective date.
            Continued use of the Service after updates constitutes acceptance of the revised Terms.
        </p>

        <h2 className="terms__sub-heading">15. Governing Law</h2>
        <p className="terms__description">
            These Terms are governed by the laws of the State of Florida, USA, without regard to conflict-of-law principles.
            Any disputes shall be resolved exclusively in the state or federal courts of Florida.
        </p>

        <h2 className="terms__sub-heading">16. Contact Us</h2>
        <p className="terms__description">
            If you have any questions about these Terms, please contact us at:
            <a href="mailto:trevor@amplifyloyalty.com"> trevor@amplifyloyalty.com</a>.
        </p>
    </div>
  );
}